import React, { Component } from "react";
import GLOBALS from '../utils/Constants';
import CryptoJS from 'crypto-js'
import moment from 'moment-timezone';
import UserService from './users-service';


export default class ReportsService {

    static sharedInstance = ReportsService.sharedInstance == null ? new ReportsService() : this.sharedInstance;

    constructor() {
        //UserService.sharedInstance.checkIfTokenIsValid();
    }


    async upload(params){
        const data = new FormData();

        data.append("file", params.file);
        data.append("auth_username", params.auth_username);
        data.append("token", params.token);
        data.append("license", params.license);
        data.append("sub_user_id", params.sub_user_id);

        const response = await fetch(GLOBALS.UPLOAD_REPORT_API, {
            method: 'POST',
            body: data
        });


        const responseJson = await response.json();
        try {;
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    //edit with file
    async edit(params){
        const data = new FormData();

        data.append("file", params.file); //file to be uploaded if edited
        data.append("auth_username", params.auth_username);
        data.append("token", params.token);
        data.append("license", params.license);
        data.append("id", params.id); //id of the report here

        const response = await fetch(GLOBALS.UPLOAD_REPORT_API, { //same API path is used for uploading and editing
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        try {
            //console.log(responseJson);
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    async editByName(params){
        /* params will look like this
        let params = {
             "license": "",
             "token": "",
             "auth_usernam": "",
             "id": "" //id of the report being edited,
             "name": "xxx" //updated name of the report
        };*/
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.EDIT_REPORT_API, {
            method: 'PUT',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    async delete(params){
        /* params will look like this
        let params = {
             "license": "",
             "token": "",
             "auth_username": "",
             "id": //id of the report
        };*/
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.DELETE_REPORT_API, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            // UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    //Josh see the 2 API functions below where it fetch reports either by license or by user
    async fetchReports(license, username, token){
        const params = {
            "license": license,
            "auth_username": username,
            "token": token,
        }

        // console.log("fetch users params: ", params);

        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.GET_REPORTS_BY_LICENSE_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            //console.log(responseJson);
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;

        } catch (error) {
            console.error("error");
            console.error(error);
            // alert("Reports fetching failed.");
        }
    }

    async fetchReportsByLicense(params){

       /* params will look like this
        let params = {
             "license": "",
             "token": "",
             "auth_usernam": ""
        };*/
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.GET_REPORTS_BY_LICENSE_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            //console.log(responseJson);
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;

        } catch (error) {
            console.error("error");
            console.error(error);
            alert("Reports fetching failed.");
        }
    }

    async fetchReportsByUser(params){

       /* params will look like this
        let params = {
             "license": "",
             "token": "",
             "auth_usernam": "",
             "sub_user_id": "" //id of the logged in user
        };*/
        const formBody = UserService.sharedInstance.urlEncodeParams(params);

        const response = await fetch(GLOBALS.GET_REPORTS_BY_USER_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            //console.log(responseJson);
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;

        } catch (error) {
            console.error("error");
            console.error(error);
            alert("Reports fetching failed.");
        }
    }
}